import { AxiosResponse } from 'axios'

export class AccessDenied<ErrorReason = unknown> extends Error {
  public response?: AxiosResponse<ErrorReason>
  constructor(response?: AxiosResponse<ErrorReason>) {
    super()
    this.response = response
  }
}

export enum AccessDeniedReasonsEnum {
  Deactivated = 'course_deactivated',
  OwnerRestricted = 'owner_restricted',
  BlockedByProgress = 'progress_blocked',
  BlockedByQuiz = 'quiz_was_not_passed',
}

export function getAccessDeniedText(reason?: AccessDeniedReasonsEnum | null) {
  let errorText = '403 - Access Denied'

  if (reason && Object.values(AccessDeniedReasonsEnum).includes(reason)) {
    errorText = 'core.error.access_unavailable'
  }

  return errorText
}
